import { alpha, ListItemButton, ListItemIcon } from '@mui/material';
import styled from 'styled-components';

export const DrawerButton = styled(ListItemButton)<{ $isOpen: boolean }>(
  ({ theme, $isOpen }) => ({
    '&.MuiListItemButton-root': {
      color: theme.color['cream-100'].hex,
      minHeight: '48px',
      justifyContent: $isOpen ? 'initial' : 'center',
      paddingLeft: theme.spacing(2.5),
      paddingRight: theme.spacing(2.5),
    },
  }),
);

export const DrawerIcon = styled(ListItemIcon)<{ $isOpen: boolean }>(
  ({ theme, $isOpen }) => ({
    '&.MuiListItemIcon-root': {
      color: alpha(theme.color['cream-100'].hex, 0.2),
      marginRight: $isOpen ? theme.spacing(1) : 'auto',
      minWidth: 0,
    },
  }),
);
